import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutLateralComponent } from './global/visualizacao/fragmentos/layout-lateral/layout-lateral.component';
import { DashboardUsuarioComponent } from './global/telas/dashboard-usuario/dashboard-usuario.component';
import { TelaAutenticacaoComponent } from './frameworks/seguranca/telas/tela.autenticacao/tela.autenticacao.component';
import { GuardaUsuarioAutenticadoService } from './frameworks/seguranca/guardas/guarda-usuario-autenticado.service';
import { GuardaUsuarioNaoAutenticadoService } from './frameworks/seguranca/guardas/guarda-usuario-nao-autenticado.service';
import { GuardaAcessoDashboardGuard } from './global/guardas/guarda-acesso-dashboard.guard';
import { JanelaUsuarioComponent } from './fichas/janelas/janela-usuario/janela-usuario.component';
import { GuardaAcessoModuloService } from 'src/app/frameworks/seguranca/guardas/guarda-acesso-modulo.service';
import { MensagemComponent } from './modulos/mensagem/mensagem.component';
import { IntranetComponent } from './modulos/intra-net/intra-net.component';

const routes: Routes = [
  // ROTA DE AUTENTICAÇÃO (fica fora do layout principal, não tem sidebar)
  {
    path: "autenticacao",
    component: TelaAutenticacaoComponent,
    canActivate: [GuardaUsuarioNaoAutenticadoService]
  },

  // ROTA PAI QUE USA O NOVO LAYOUT
  // Todas as rotas "filhas" (children) serão renderizadas dentro deste componente
  {
    path: '', // Caminho base da aplicação após o login
    component: LayoutLateralComponent,
    canActivate: [GuardaUsuarioAutenticadoService], // Protege todas as rotas filhas de uma só vez
    children: [
      //"FILHAS" DO LAYOUT
      { path: 'intranet', component: IntranetComponent },
      { path: "principal", component: DashboardUsuarioComponent },
      { path: "telemarketing", loadChildren: () => import('./modulos/telemarketing/telemarketing.module').then(m => m.TelemarketingModule), canActivate: [GuardaAcessoDashboardGuard] },
      { path: "comercial", loadChildren: () => import('./modulos/comercial/comercial.module').then(m => m.ComercialModule), canActivate: [GuardaAcessoDashboardGuard] },
      { path: "diversos", loadChildren: () => import('./modulos/diversos/diversos.module').then(m => m.DiversosModule) },
      { path: "gestaoInterna", loadChildren: () => import('./modulos/gestao-interna/gestao-interna.module').then(m => m.GestaoInternaModule), canActivate: [GuardaAcessoDashboardGuard] },
      { path: "financeiro", loadChildren: () => import('./modulos/financeiro/financeiro.module').then(m => m.FinanceiroModule), canActivate: [GuardaAcessoDashboardGuard] },
      { path: "integracao", loadChildren: () => import('./integracoes/integracoes.module').then(m => m.IntegracoesModule), canActivate: [GuardaAcessoDashboardGuard] },
      { path: "operacoes", loadChildren: () => import('./modulos/operacoes/operacoes.module').then(m => m.OperacoesModule), canActivate: [GuardaAcessoDashboardGuard] },
      { path: "anuenciaEletronica", loadChildren: () => import('./modulos/anuencia-eletronica/anuencia-eletronica.module').then(m => m.AnuenciaEletronicaModule), canActivate: [GuardaAcessoDashboardGuard] },
      { path: "controleAprovacao", loadChildren: () => import('./modulos/controle-aprovacao/controle-aprovacao.module').then(m => m.ControleAprovacaoModule) },
      { path: "seguranca", loadChildren: () => import('./frameworks/seguranca/seguranca.module').then(m => m.SegurancaModule), canActivate: [GuardaAcessoDashboardGuard] },
      { path: "producao", loadChildren: () => import('./modulos/producao/producao.module').then(m => m.ProducaoModule), canActivate: [GuardaAcessoDashboardGuard] },
      { path: "publico", loadChildren: () => import('./modulos/publico/publico.module').then(m => m.PublicoModule) },
      { path: "compliance", loadChildren: () => import('./modulos/compliance/compliance.module').then(m => m.ComplianceModule), canActivate: [GuardaAcessoDashboardGuard] },
      { path: "contabilidade", loadChildren: () => import('./modulos/contabilidade/contabilidade.module').then(m => m.ContabilidadeModule), canActivate: [GuardaAcessoDashboardGuard] },
      { path: "gestao-recebimento", loadChildren: () => import('./modulos/recebimento/recebimento.module').then(m => m.RecebimentoModule), canActivate: [GuardaAcessoDashboardGuard] },
      { path: "cosseguro-alfa", loadChildren: () => import('./modulos/cosseguro-alfa/cosseguro.module').then(m => m.CosseguroModule), canActivate: [GuardaAcessoModuloService] },
      { path: "atuarial", loadChildren: () => import('./modulos/atuarial/atuarial.module').then(m => m.AtuarialModule), canActivate: [GuardaAcessoModuloService] },
      { path: "arrecadacao", loadChildren: () => import('./modulos/arrecadacao/arrecadacao.module').then(m => m.ArrecadacaoModule), canActivate: [GuardaAcessoModuloService] },
      { path: "mensagem", component: MensagemComponent },

      // Rota padrão: se o utilizador aceder a "meusite.com/", será redirecionado para "/principal"
      { path: '', redirectTo: 'principal', pathMatch: 'full' }
    ]
  },

  // ROTA PARA O OUTLET NOMEADO (não precisa estar dentro do layout principal)
  {
    path: "visualizarUsuario/:idUsuario",
    outlet: "janelaLateralUsuario",
    component: JanelaUsuarioComponent
  },

  // ROTA "CORINGA": Se nenhuma rota acima corresponder, redireciona para a autenticação
  { path: '**', redirectTo: 'autenticacao' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }